import { LeadApi } from "../../../apis/lead.api";
import { TLastPageRequest } from "../../../models/last-update-page-request";
import { withRxJs } from "../../hoc/with-rx";
import { MenuBarComponent } from "./menuBar.component";

const MenuBarContainer = withRxJs(MenuBarComponent)(() => {
	// const user$ = UserApi.getUser().map(value => value.toOption());
	//.do(user => user.map(u => LeadApi.advisorId$.next(u.roles[0].aplId.getOrElse(''))));
	return {
		defaultProps: {
			updateLastPage: (page: TLastPageRequest) => {
				LeadApi.lastPageVisited(page);
			}
		},
		props: {
			
		},
	};
});

export default MenuBarContainer;